import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrDownloadIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M5.21023 7.69012C5.08023 7.56012 5.00023 7.38012 5.00023 7.19012C5.00023 7.00012 5.07023 6.82012 5.21023 6.69012C5.47023 6.43012 5.94023 6.43012 6.20023 6.69012L7.50023 8.00012V2.69012C7.50023 2.50012 7.57023 2.33012 7.70023 2.19012C7.96023 1.93012 8.43023 1.93012 8.69023 2.19012C8.82023 2.32012 8.90023 2.50012 8.90023 2.69012V8.00012L10.2002 6.69012C10.4702 6.43012 10.9202 6.43012 11.1902 6.69012C11.3202 6.82012 11.4002 7.00012 11.4002 7.19012C11.4002 7.38012 11.3202 7.56012 11.1902 7.69012L8.69023 10.1901C8.63023 10.2501 8.55023 10.3101 8.46023 10.3401C8.37023 10.3801 8.28023 10.3901 8.19023 10.3901C8.10023 10.3901 8.01023 10.3701 7.92023 10.3401C7.83023 10.3001 7.76023 10.2501 7.69023 10.1901L5.19023 7.69012H5.21023ZM14.2002 9.20012C13.9302 8.94012 13.4802 8.94012 13.2102 9.20012C13.0802 9.33012 13.0002 9.51012 13.0002 9.70012V13.0001H3.40023V9.70012C3.40023 9.51012 3.33023 9.34012 3.19023 9.20012C2.93023 8.94012 2.46023 8.94012 2.20023 9.20012C2.07023 9.33012 1.99023 9.51012 1.99023 9.70012V13.2001C1.99023 13.5201 2.11023 13.8201 2.34023 14.0501C2.57023 14.2801 2.87023 14.4001 3.19023 14.4001H13.1902C13.5102 14.4001 13.8102 14.2801 14.0402 14.0501C14.2702 13.8201 14.3902 13.5201 14.3902 13.2001V9.70012C14.3902 9.51012 14.3202 9.34012 14.1802 9.20012H14.2002Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrDownloadIconComponent;
